import { buildModelManager } from "../builder.js";
const DefaultWhatsappWebhookSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customerId: true,
  data: true,
  isFromWhatsappDirectly: true,
  isProcessed: true,
  origin: true,
  timestamp: true,
  updatedAt: true
};
const modelApiIdentifier = "whatsappWebhook";
const pluralModelApiIdentifier = "whatsappWebhooks";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappWebhookSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappWebhookSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappWebhookSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappWebhookSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWhatsappWebhook",
    operationReturnType: "CreateWhatsappWebhook",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      whatsappWebhook: { required: false, type: "CreateWhatsappWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWhatsappWebhooks",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateWhatsappWebhooksInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappWebhookSelection
  },
  {
    type: "action",
    operationName: "updateWhatsappWebhook",
    operationReturnType: "UpdateWhatsappWebhook",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      whatsappWebhook: { required: false, type: "UpdateWhatsappWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWhatsappWebhooks",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateWhatsappWebhooksInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappWebhookSelection
  },
  {
    type: "action",
    operationName: "deleteWhatsappWebhook",
    operationReturnType: "DeleteWhatsappWebhook",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWhatsappWebhooks",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertWhatsappWebhook",
    operationReturnType: "UpsertWhatsappWebhook",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      whatsappWebhook: { required: false, type: "UpsertWhatsappWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWhatsappWebhookResult": { hasReturnType: false },
      "... on UpdateWhatsappWebhookResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWhatsappWebhooks",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertWhatsappWebhooksInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWhatsappWebhookSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "whatsappWebhookGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WhatsappWebhookManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWhatsappWebhookSelection,
  operations
);
export {
  DefaultWhatsappWebhookSelection,
  WhatsappWebhookManager
};
//# sourceMappingURL=WhatsappWebhook.js.map
